export default __webpack_public_path__ + "static/media/ChooseColor.55d3bbe1.png";